import { lazy } from 'react';

const AuthHeader = lazy(() => import('./AuthHeader'));

export default AuthHeader;
